"use client";

import { useMemo } from "react";
import { getCvvSize } from "@tillix/utils";
import { useWatch } from "react-hook-form";
import {
  getCardLengthRange,
  getCardType,
  type PaymentType,
} from "react-svg-credit-card-payment-icons";
import type { CardNetworkContextValue } from "./cardNetworkContext";

export function useCardNetwork(
  fieldName = "cardNumber",
): CardNetworkContextValue {
  const value = useWatch({ name: fieldName }) as string | undefined;

  return useMemo(() => {
    const digits = value ?? "";
    const type: PaymentType =
      digits.length > 0 ? getCardType(digits) : "Generic";
    const range = type === "Generic" ? null : getCardLengthRange(type);
    return {
      type,
      cvvSize: getCvvSize(digits),
      maxCardLength: range?.max ?? 19,
    };
  }, [value]);
}
